import React, {memo} from 'react'

import ComingSoon from '../../commons/ComingSoon'

const Pages = () => {

  return (
    <>
      <ComingSoon />
    </>
  )
}

export default memo(Pages)
